<template>
    <b-modal
        id="org-chart-detail-modal"
        v-model="modal"
        modal-class="apprentice-default-modal org-chart-modal"
        size="sm"
        :title="$t('common.edit_skill')"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        :hide-footer="!edit"
        @ok="onOk">
        <b-form-input v-model="title"> </b-form-input>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-org-chart-detail-modal-component',
    props: ['skillTreeIn'],
    data() {
        return {
            nodeId: 0,
            nodePid: 0,
            modal: false,
            edit: false,
            title: '',
            skill_id: null,
        };
    },
    methods: {
        show(nodeId, nodes, editMode) {
            this.edit = editMode;

            // todo first gebruiken
            for (const node of nodes) {
                if (node.id === nodeId) {
                    this.nodeId = nodeId;
                    this.pid = node.pid;
                    this.title = node.name;
                    this.modal = true;
                    this.skill_id = node.skill_id;
                }
            }
        },
        onOk() {
            let data = {
                id: this.nodeId,
                skill_tree_id: this.skillTreeIn.id,
                name: this.title,
                pid: this.pid,
                rubrics: [],
                skill_id: this.skill_id,
            };

            this.$emit('update-node', data);

            this.modal = false;
            this.edit = false;
        },
    },
};
</script>

<style scoped></style>
